import type { File } from "app/util/workspace";
client import { compress, decompress } from "app/util/hasher";
export interface Input {
  value: File[];
}

let/value=[] as File[]
lifecycle
  ,onMount() {
    decompress(window.location.hash.slice(1)).then((decompressed) => {
      value = JSON.parse(decompressed) || input.value;
    });
  }
  ,onUpdate() {
    compress(JSON.stringify(value)).then((compressed) => {
      // Replace the current entry instead of assigning location.hash, which
      // would push a new history entry on every edit and flood the back button.
      history.replaceState(history.state, "", "#" + compressed);
    });
  }

return:=value
